module.exports = __webpack_public_path__ + "img/samkay.067bc4aa.png";